import clsx from 'clsx';
import React from 'react';

import RectButton from '../../RectButton/RectButton';
import styles from './Buttons.module.scss';

type BottomSheetButton = {
  disabled?: boolean;
  label: React.ReactElement | string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export type BottomSheetButtonSet =
  | ({ caption?: string; type: 'confirm'; style: 'primary' | 'basic' } & BottomSheetButton)
  | { caption?: string; type: 'decision'; main: BottomSheetButton; sub: BottomSheetButton }
  | { type: 'reset'; main: BottomSheetButton; reset: BottomSheetButton };

interface IButtonsProps {
  children: BottomSheetButtonSet;
}

const Buttons: React.FC<IButtonsProps> = ({ children }: IButtonsProps) => {
  if (children.type === 'reset') {
    return (
      <footer className={styles.container}>
        <div className={styles.buttonContainer}>
          <RectButton.Basic
            className={clsx(styles.subButton, children.reset.disabled && styles.disabled)}
            as="button"
            disabled={children.reset.disabled}
            onClick={children.reset.onClick}
          >
            {children.reset.label}
          </RectButton.Basic>
          <RectButton.Primary
            className={styles.mainButton}
            as="button"
            disabled={children.main.disabled}
            onClick={children.main.onClick}
          >
            {children.main.label}
          </RectButton.Primary>
        </div>
      </footer>
    );
  }

  if (children.type === 'confirm') {
    return (
      <footer className={styles.container}>
        {children.caption && <p className={styles.caption}>{children.caption}</p>}
        <div>
          {children.style === 'primary' ? (
            <RectButton.Primary
              className={styles.buttonConfirm}
              as="button"
              disabled={children.disabled}
              onClick={children.onClick}
            >
              {children.label}
            </RectButton.Primary>
          ) : (
            <RectButton.Basic
              className={styles.buttonConfirm}
              as="button"
              disabled={children.disabled}
              onClick={children.onClick}
            >
              {children.label}
            </RectButton.Basic>
          )}
        </div>
      </footer>
    );
  }

  return (
    <footer className={styles.container}>
      {children.caption && <p className={styles.caption}>{children.caption}</p>}
      <div className={styles.decisionContainer}>
        <RectButton.Blue
          className={styles.buttonDecision}
          as="button"
          disabled={children.sub.disabled}
          onClick={children.sub.onClick}
        >
          {children.sub.label}
        </RectButton.Blue>
        <RectButton.Primary
          className={styles.buttonDecision}
          as="button"
          disabled={children.main.disabled}
          onClick={children.main.onClick}
        >
          {children.main.label}
        </RectButton.Primary>
      </div>
    </footer>
  );
};

export default Buttons;
